"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Button = Button;
exports.enhance = exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clickTracking = _interopRequireDefault(require("./tracking-lib/tracking/clickTracking"));

/* eslint-disable react/button-has-type */
var enhance = _clickTracking["default"];
exports.enhance = enhance;

function Button(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      handleClick = _ref.handleClick,
      className = _ref.className,
      type = _ref.type,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      getRef = _ref.getRef;
  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    disabled: disabled,
    className: className,
    type: type,
    ref: getRef
  }, children);
}

Button.propTypes = {
  children: _propTypes["default"].node,
  handleClick: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  getRef: _propTypes["default"].func
};
Button.defaultProps = {
  type: 'button'
};

var _default = enhance(Button);

exports["default"] = _default;